import { decryptData } from "helpers/crypto_helper";

export const useAuthUserDetails = () => {
  const storedAuthUser = localStorage.getItem("authUser");
  if (!storedAuthUser) return null;

  try {
    const decryptedString = decryptData(storedAuthUser);
    const authUser = JSON.parse(decryptedString);

    if (authUser && authUser.data) {
      const { employee_details = [], user_id } = authUser.data;
      const unit_id = localStorage.getItem("unit_id");

      const updatedEmployeeDetails = employee_details.map((employee) => ({
        ...employee,
        user_id,
        unit_id,
      }));

      return updatedEmployeeDetails;
    }
  } catch (error) {
    console.error("Error processing authUser:", error);
  }

  return null;
};
